var _a;
export var DirectionsEnum;
(function (DirectionsEnum) {
    DirectionsEnum["LTR"] = "ltr";
    DirectionsEnum["RTL"] = "rtl";
})(DirectionsEnum || (DirectionsEnum = {}));
export default class Language {
    constructor() {
    }
}
_a = Language;
Language.setLanguage = (lang) => {
    if (!Language.supported_languages[lang])
        throw new Error("The Language Isn't Supported");
    _a.language = _a.supported_languages[lang];
};
Language.init = (init) => {
    _a.supported_languages = init.supported_languages;
    _a.setLanguage(init.languageKey);
};
